// apps/web/src/pages/pcp/nova-op-liberacao.ts — atualização da OP exibida em /producao/nova-op depois da liberação.
//
// A liberação congela o snapshot do roteiro e gera as OS no servidor; o resultado do diálogo só traz
// `{ id, status }`. Por isso a tela relê a OP (GET /producao/ops/:id, que já devolve snapshot e OS) em vez de
// apenas trocar o status, para não continuar mostrando "Rascunho (versão viva)" e a lista de OS vazia.
import { apiFetch } from '../../lib/csrf-fetch';

export const TEXTO_FALHA_RELEITURA_OP = 'A OP foi liberada, mas não foi possível atualizar os dados desta tela. Recarregue a página para conferir as Ordens de Serviço geradas.';

export interface OpComStatus {
  readonly id: string;
  readonly status: string;
}

export interface ResultadoOpAposLiberacao<T extends OpComStatus> {
  readonly op: T;
  readonly erro: string | null;
}

export function buscarOpPorId<T>(opId: string): Promise<T> {
  return apiFetch<T>(`/api/v1/producao/ops/${encodeURIComponent(opId)}`);
}

/**
 * Relê a OP liberada. Resultado de outra OP (diálogo antigo) não altera a tela. Se a releitura falhar, aplica ao
 * menos o status devolvido pela liberação e devolve um aviso; nunca inventa snapshot nem OS.
 */
export async function opAtualizadaAposLiberacao<T extends OpComStatus>(
  atual: T,
  liberada: OpComStatus,
  buscar: (opId: string) => Promise<T> = buscarOpPorId,
): Promise<ResultadoOpAposLiberacao<T>> {
  if (liberada.id !== atual.id) return { op: atual, erro: null };
  try {
    return { op: await buscar(atual.id), erro: null };
  } catch {
    return { op: { ...atual, status: liberada.status }, erro: TEXTO_FALHA_RELEITURA_OP };
  }
}
